import FormattedMessage from 'I18n/components/FormattedMessage';
import { ContainerTemplate } from './ContainerTemplate';
import { InstallPermissionsTile } from '../installPermissions/InstallPermissionsTile';
import { InstallPermissionsDowngradeAlert } from '../installPermissions/InstallPermissionsDowngradeAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InstallPermissions() {
  return /*#__PURE__*/_jsxs(ContainerTemplate, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.installPermissions.description"
    }),
    children: [/*#__PURE__*/_jsx(InstallPermissionsDowngradeAlert, {}), /*#__PURE__*/_jsx(InstallPermissionsTile, {})]
  });
}